import { createAsyncThunk } from '@reduxjs/toolkit';
import { UPDATEPROFILE_API_URL } from '@custom/constant';

const updateProfileApi = createAsyncThunk('updateProfile', async (values: any) => {
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');

    const payload = {
        ...values,
        hospitalId: hospitalId,
        _id: userId
    }

    try {
        let url = `${UPDATEPROFILE_API_URL}`;
        let response = await fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: 'Bearer ' + token,
                'content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return await response.json()
    } catch (error) {
        return error;
    }
});

export default updateProfileApi;
